import React from "react";
//
import Post from "./post";
//
export default ({ posts }) => {
  if (!posts || posts.length < 1) {
    return null;
  }

  return posts.map(post => <Post key={post.postid} {...post} />);
};
